import { Flex, Stack, Text, TextInput,Title,MultiSelect, Button, Radio, Select, Textarea,Group, Checkbox,Paper,Grid,NumberInput } from '@mantine/core'
import { DatePicker } from '@mantine/dates';
import 'dayjs/locale/fr-ca';
import { useForm } from '@mantine/form'
import React,{useState} from 'react'
import InputMask from 'react-input-mask';
import { patchMember } from '../connections/requests';

export default function MemberInfoEdit(props) {
    let { prenom, nom, dateOfBirth,dateOfRegistration,dateOfMembership,dateOfArrivalCountry,dateOfArrivalRegion,dateOfImmigrationStatus } = props.member
        const [languageAdd, setLanguage] = useState([
            { value: 'Francais', label: 'Francais' },
            { value: 'Anglais', label: 'Anglais' },
            { value: 'Espagnol', label: 'Espagnol' },
            { value: 'Creole', label: 'Creole' },
            { value: 'Arabe', label: 'Arabe' },
          ]);
    const form = useForm({ initialValues: { ...props.member,active:"inactive", dateOfBirth: new Date(dateOfBirth),dateOfRegistration : new Date(dateOfRegistration),dateOfMembership : new Date(dateOfMembership),dateOfArrivalCountry:new Date(dateOfArrivalCountry),dateOfArrivalRegion:new Date(dateOfArrivalRegion),dateOfImmigrationStatus:new Date(dateOfImmigrationStatus) } })
    return (
        <form>
            <Text size={"lg"} c={"dimmed"} align='center'>Modifier les infos pour l'usage {`${prenom} ${nom}`}</Text>
                       <Stack>
                           <Grid >
                               <Grid.Col span={6}>
                               <TextInput label="Prénom" placeholder=""  {...form.getInputProps('prenom')} />
                               </Grid.Col>
                               <Grid.Col span={6}>
                               <TextInput label="Nom" placeholder=""  {...form.getInputProps('nom')} />
                               </Grid.Col>
                           </Grid>
                           <Radio.Group name="genre" {...form.getInputProps('genre')} label="Genre">
                               <Radio value="homme" label="Homme" />
                               <Radio value="femme" label="Femme" />
                               <Radio value="nonbinaire" label="Non-Binaire / Autre" />
                           </Radio.Group>
                           <TextInput label="Courriel"  {...form.getInputProps('email')} />
                           <TextInput label="Adresse Civique" placeholder=""  {...form.getInputProps('civic')} />
                           <TextInput label = "Ville" placeholder=""  {...form.getInputProps("city")}/>
                           <TextInput label="Code Postal" placeholder=""  {...form.getInputProps('postal')} />
                           <TextInput component={InputMask} mask="(999) 999-9999" label="Téléphone"  {...form.getInputProps('phone')} />
                           <Select mb={"lg"}
                               style={{ marginTop: 20, zIndex: 2 }}
                               data={['Téléphone', 'Courriel', 'Poste', 'Autres']}
                               placeholder={""}
                               label="Préférence de communication"
                               {...form.getInputProps('commPref')}
                           />
                           <Grid>
                               <Grid.Col span={10}>

                           <DatePicker
                               inputFormat='DD MMMM YYYY'
                               labelFormat='DD/MMMM/YYYY'
                               locale='fr-ca'
                               label="Date de Naissance"
                               
                               allowFreeInput
                               clearable={false}
                               {...form.getInputProps('dateOfBirth')}
                           />
                         </Grid.Col> </Grid>
                           <Group>
                           <Select
                               data={["Demandeur d'asile","Réfugié protégé","Résident permanent","Citoyen","Travailleur temporaire","Étudiant étranger"]}
                               label="Catégorie d'immigration"
                               searchable
                               {...form.getInputProps("immigrationStatus")}
                           />
                           <DatePicker
                               inputFormat='DD MMMM YYYY'
                               labelFormat='DD/MMMM/YYYY'
                               locale='fr-ca'
                               label="Date du statut"
                               allowFreeInput
                               clearable={false}
                               {...form.getInputProps('dateOfImmigrationStatus')}
                           />
                           
                           <DatePicker
                               inputFormat='DD MMMM YYYY'
                               labelFormat='DD/MMMM/YYYY'
                               locale='fr-ca'
                               label="Date d'arrivé au Canada"
                               allowFreeInput
                               clearable={false}
                               {...form.getInputProps('dateOfArrivalCountry')}
                           />
                           <DatePicker
                               inputFormat='DD MMMM YYYY'
                               labelFormat='DD/MMMM/YYYY'
                               locale='fr-ca'
                               label="Date d'arrivé MRC"
                               allowFreeInput
                               clearable={false}
                               {...form.getInputProps('dateOfArrivalRegion')}
                           />
                           </Group>
                           <Group>
                           <TextInput
                               
                               label="Pays de naissance"
                               searchable
                               nothingFound="Nothing found"
                               {...form.getInputProps("countryOfOrigins")}
                               />
                           <Select
                               data={["Français","Anglais","Espagnol","Autres"]}
                               label="Langue de contact"
                               searchable
                               nothingFound="Nothing found"
                               {...form.getInputProps("principalLanguages")}
                               />
                           <MultiSelect
                               data={languageAdd}
                               label="Autres langues"
                               searchable
                               creatable
                               getCreateLabel={(query) => `+ Create ${query}`}
                               onCreate={(query) => {
                               const item = { value: query, label: query };
                               setLanguage((current) => [...current, item]);
                               return item;
                               }}
                               nothingFound="Nothing found"
                               {...form.getInputProps("languages")}
                               />
                               </Group>
           
                           <Select
                               data={["Marié","Célibataire","Divorcé","Séparé","Conjoint de fait","Veuf"]}
                               label="État civil"
                               searchable
                               {...form.getInputProps("maritalStatus")}
                           />
                           <Select
                               data={["Salarié Temps Plein","Salarié Temps Partiel","Travailleur autonome","Sans Emploi avec assurance emploi","Sans Emploi sans assurance emploi","Retraité","Arrêt de Travail","Autres"]}
                               label="Statut d'emploi"
                               searchable
                               {...form.getInputProps("employmentStatus")}
                           />
                           <Group>
                               <TextInput
                                   label="Diplômes"
                                   {...form.getInputProps("education.diplomas")}
                                   />
                               <TextInput label = "Domaine d'Étude" placeholder="" {...form.getInputProps("education.fieldOfStudy")}/>
                           </Group>
                           <Group>
                               <TextInput
                                   label="Référence"
                                   {...form.getInputProps("reference")}
                               />
                           </Group>
            
             
            </Stack>
            <Button onClick={() => patchMember(form).then(props.callback())}>Soumettre</Button>
        </form>

    )
}
